export default __webpack_public_path__ + "static/media/infoCircle.0fc719d7.svg";